<template>
  <fragment>
    <hero-header page-name="" hero-title="impress"/>
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="text-center">
          <template v-for="(item, index) in $store.state.generalStore.companyDetails">
            <div :key="index" class="mb-6">
              <p class="mb-0">
                {{ $t(`${item.title}`) }}:
              </p>
              <p class="headline primary--text text--darken-3 mb-0">
                {{ item.value }}
              </p>
              <p v-if="item.extra">
                {{ $t('headquarter') }}: {{ item.extra }}
              </p>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';

export default {
  name: 'impresszum',
  components: {
    heroHeader,
  },
  data() {
    return {
      foo: 'bar',
    };
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
